var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaretDownIconGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 0.871094C5.425 0.871094 0.5 5.79609 0.5 11.8711C0.5 17.9461 5.425 22.8711 11.5 22.8711C17.575 22.8711 22.5 17.9461 22.5 11.8711C22.5 5.79609 17.575 0.871094 11.5 0.871094ZM8.207 9.66409C8.0184 9.48194 7.7658 9.38114 7.5036 9.38342C7.2414 9.3857 6.99059 9.49087 6.80518 9.67628C6.61977 9.86168 6.5146 10.1125 6.51233 10.3747C6.51005 10.6369 6.61084 10.8895 6.793 11.0781L10.793 15.0781C10.9805 15.2656 11.2348 15.3709 11.5 15.3709C11.7652 15.3709 12.0195 15.2656 12.207 15.0781L16.207 11.0781C16.3892 10.8895 16.49 10.6369 16.4877 10.3747C16.4854 10.1125 16.3802 9.86168 16.1948 9.67628C16.0094 9.49087 15.7586 9.3857 15.4964 9.38342C15.2342 9.38114 14.9816 9.48194 14.793 9.66409L11.5 12.9571L8.207 9.66409Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDownIconGray);
export default __webpack_public_path__ + "static/media/caret-down-icon-gray.c72c928a27e533a8078aa42aeff4628f.svg";
export { ForwardRef as ReactComponent };